import { useQuery } from "@tanstack/react-query";
import { ExperimentRepository } from "../../domain/interfaces/ExperimentRepository";
import { ExperimentEntity } from "../../domain/experiment.entity";
import { experimentsQueryKeys } from "../../infrastructure/cache/ExperimentsCacheStrategy";

export function useExperiment(
  propertyTicker: string,
  id: string | undefined,
  repository: ExperimentRepository
) {
  return useQuery({
    queryKey: experimentsQueryKeys.detail(propertyTicker, id ?? ""),
    queryFn: async (): Promise<ExperimentEntity> => {
      if (!id) throw new Error("Experiment ID is required");
      const experiment = await repository.findById(id);
      if (!experiment) throw new Error("Experiment not found");
      return experiment;
    },
    enabled: !!id,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: (failureCount, error) => {
      if (error instanceof Error && error.message.includes("not found")) return false;
      return failureCount < 3;
    },
  });
}
